export default __webpack_public_path__ + "static/media/more-icon.012b4234.svg";